import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginLeft: 'auto',
    '& > *': {
      margin: theme.spacing(0),
    },
  },
  menu: {
    marginTop: '30px',
  },
  input: {
    display: 'none',
  },
  user: {
    color: theme.palette.text.disabled,
    padding: '6px 16px',
  },
}));

export default useStyles;
